import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Box, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, VStack, Input, Select } from '@chakra-ui/react';
import ConfigChangeList from './ConfigChangeList';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfigurationAudit } from '../../actions/configurations';
import { configurationUtils } from '@codametrix/ui-common';
const { serviceLineAliases } = configurationUtils;
const invertedServiceLineAliases = Object.fromEntries(Object.entries(serviceLineAliases ?? {}).map(([key, value])=>[
        value,
        key
    ]));
const ConfigurationHistoryDrawer = ({ isOpen, onClose, tenantId, tenantName })=>{
    const [searchKey, setSearchKey] = useState('');
    const [submittedSearchKey, setSubmittedSearchKey] = useState('');
    const [serviceLine, setServiceLine] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const dispatch = useDispatch();
    const activeContext = useSelector((state)=>state.ui.context.activeContext);
    const { serviceLines = [] } = activeContext || {};
    // Get audit history from Redux store
    const configurationAuditData = useSelector((state)=>state.configurations.configurationAuditHistory);
    // Fetch audit history when drawer opens or filters change
    useEffect(()=>{
        if (isOpen && tenantId) {
            const serviceLineForFetch = serviceLine === 'Bedside Pro' ? 'Inpatient Professional Coding' : serviceLine;
            dispatch(fetchConfigurationAudit({
                tenantId,
                pageNumber: pageNumber || 1,
                pageSize: 20,
                serviceLine: serviceLineForFetch || undefined,
                searchKey: submittedSearchKey || undefined
            }));
        }
    }, [
        isOpen,
        pageNumber,
        tenantId,
        serviceLine,
        submittedSearchKey,
        dispatch
    ]);
    const handleServiceLineChange = (e)=>{
        const selectedValue = e.target.value;
        setPageNumber(1);
        setServiceLine(selectedValue);
    };
    const handleSearchKeyChange = (e)=>{
        setSearchKey(e.target.value);
    };
    const handleSearchKeySubmit = (e)=>{
        if (e.key === 'Enter') {
            setPageNumber(1);
            setSubmittedSearchKey(searchKey);
        }
    };
    const handlePageChange = (newPageNumber)=>{
        if (newPageNumber !== pageNumber) {
            setPageNumber(newPageNumber);
        }
    };
    return /*#__PURE__*/ _jsxs(Drawer, {
        isOpen: isOpen,
        placement: "right",
        size: "md",
        onClose: onClose,
        blockScrollOnMount: false,
        children: [
            /*#__PURE__*/ _jsx(DrawerOverlay, {}),
            /*#__PURE__*/ _jsxs(DrawerContent, {
                maxH: "100vh",
                display: "flex",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ _jsx(DrawerCloseButton, {}),
                    /*#__PURE__*/ _jsxs(DrawerHeader, {
                        flexShrink: 0,
                        pr: "5rem",
                        children: [
                            "Configuration Change History For ",
                            tenantName
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(DrawerBody, {
                        flex: "1",
                        minH: 0,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        pt: 2,
                        children: [
                            /*#__PURE__*/ _jsxs(VStack, {
                                spacing: 5,
                                align: "stretch",
                                flexShrink: 0,
                                children: [
                                    /*#__PURE__*/ _jsx(Input, {
                                        placeholder: "Search",
                                        value: searchKey,
                                        onChange: handleSearchKeyChange,
                                        onKeyDown: handleSearchKeySubmit
                                    }),
                                    /*#__PURE__*/ _jsxs(Select, {
                                        placeholder: "Service Line",
                                        value: serviceLine,
                                        onChange: handleServiceLineChange,
                                        children: [
                                            /*#__PURE__*/ _jsx("option", {
                                                value: "*",
                                                children: "Tenant Default"
                                            }, "*"),
                                            serviceLines.map((sl)=>/*#__PURE__*/ _jsx("option", {
                                                    value: sl.name,
                                                    children: invertedServiceLineAliases[sl.name] || sl.name
                                                }, sl.name))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                flex: "1",
                                minH: 0,
                                minW: 0,
                                display: "flex",
                                flexDirection: "column",
                                mt: 5,
                                children: /*#__PURE__*/ _jsx(ConfigChangeList, {
                                    changes: configurationAuditData.content,
                                    auditData: configurationAuditData,
                                    onPageChange: handlePageChange
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default ConfigurationHistoryDrawer;
